import { observer } from 'mobx-react-lite';
import { User } from '../../../app/models/user';

interface Props {
    user: User
}

export default observer(function ShippingAddressContent({ user }: Props) {
    return (
        <>
            {`${user.shippingFirstName} ${user.shippingLastName}`}<br /> 
            {user.shippingAddress} {user.shippingAddress2}<br />
            {`${user.shippingCity}, ${user.shippingState} ${user.shippingZipcode}`}<br />
        </>
    )
})